import { ApolloGetQuery } from 'core/types/ApolloGetQuery';
import { logger } from 'core/utils/logger';

export const extractQueryGetItem = <T>(queryResult: ApolloGetQuery<T>) => {
  if (!queryResult) {
    logger.error(
      'GraphQL query returned undefined. This typically means the query failed or the response structure is invalid.'
    );
    return null;
  }

  const firstValue = Object.values(queryResult)[0];
  if (!firstValue) {
    logger.error(
      'GraphQL query returned null for the requested field. Check if the field exists in your schema and you have the correct permissions.'
    );
    return null;
  }

  return firstValue;
};
